export default __webpack_public_path__ + "static/media/icon-kontakt.7c2c7917.svg";